import { render, staticRenderFns } from "./SettingDrawer.vue?vue&type=template&id=dbdc7316&scoped=true&"
import script from "./SettingDrawer.vue?vue&type=script&lang=js&"
export * from "./SettingDrawer.vue?vue&type=script&lang=js&"
import style0 from "./SettingDrawer.vue?vue&type=style&index=0&id=dbdc7316&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dbdc7316",
  null
  
)

export default component.exports